export default __webpack_public_path__ + "static/media/3.0fad02b2.png";